import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import LoadingSpinner from '../common/LoadingSpinner.vue'
  import useSegment from '@/composables/useSegment'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'YoutubeModal',
  props: {
    videoId: {
      type: String,
      required: true,
    },
    contentId: {
      type: String,
      required: true,
    },
  },
  setup(__props) {

const props = __props;

  

  const player = ref(null as any)
  const { videoCompleted, videoStarted, videoPaused } = useSegment()
  const showReplayButtonOverlay = ref(false)
  const isPlayerReady = ref(false)

  const showOverlay = () => {
    showReplayButtonOverlay.value = true
  }

  const replayVideo = () => {
    player.value?.seekTo(0, true)
    showReplayButtonOverlay.value = false
  }

  const onYouTubeIframeAPIReady = (
    videoId: string,
    contentId: string,
    showOverlay: () => void,
    onPlayerReady: () => void,
  ): any => {
    if ((window as any).YT) {
      return new (window as any).YT.Player('player', {
        height: '100%',
        width: '100%',
        videoId: videoId,
        events: {
          onReady: () => {
            if (typeof onPlayerReady === 'function') onPlayerReady()
          },
          onStateChange: (e: { data: number }) => {
            onPlayerStateChange(e, contentId, showOverlay)
          },
        },
      })
    }
  }

  const onPlayerStateChange = (e: { data: number }, contentId: string, showOverlay: () => void) => {
    if (e.data === 0) {
      videoCompleted(contentId, 'external')
      showOverlay()
    } else if (e.data === 1) {
      videoStarted(contentId, 'external')
    } else if (e.data === 2) {
      videoPaused(contentId, 'external')
    }
  }

  onMounted(() => {
    player.value = onYouTubeIframeAPIReady(props.videoId, props.contentId, showOverlay, () => {
      isPlayerReady.value = true
    })
  })

return { __sfc: true,props, player, videoCompleted, videoStarted, videoPaused, showReplayButtonOverlay, isPlayerReady, showOverlay, replayVideo, onYouTubeIframeAPIReady, onPlayerStateChange, ref, onMounted, KetchUpButton, LoadingSpinner, useSegment }
}

})